/** Normalize raw `utm_affiliate` from the URL (safe for client + server). */
export function normalizeAffiliateShortCode(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const value = raw.trim().toLowerCase();
  if (!value || value.length > 64) return null;
  if (!/^[a-z0-9_-]+$/.test(value)) return null;
  return value;
}

export function affiliateClickGuardKey(storeId: string, shortCode: string): string {
  return `vupt-affiliate-click:${storeId}:${shortCode}`;
}

export function affiliateListClickGuardKey(listShortCode: string): string {
  return `vupt-affiliate-list-click:${listShortCode}`;
}

export function affiliateProfileClickGuardKey(profileShortCode: string): string {
  return `vupt-affiliate-profile-click:${profileShortCode}`;
}
